import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { changeBindEmail, returnData } from "@/api/loginConfig/addUserList";
export default {
  name: "adduserPage",
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      dialogFormVisible: false,
      titleName: "",
      id: "",
      names: '邮箱号',
      form: {
        value: ''
      },
      rules: {
        value: [{
          required: true,
          message: '请输入邮箱号',
          trigger: 'blur'
        }, {
          type: 'email',
          message: '邮箱号格式不正确',
          trigger: 'blur'
        }]
      },
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      gameId: "",
      value1: "",
      value2: [],
      searchMark: {},
      searchData: {}
    }, _defineProperty(_ref, "id", ""), _defineProperty(_ref, "formLabelWidth", "80px"), _ref;
  },
  created: function created() {
    this.searchMark = {};
  },
  watch: {},
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  methods: {
    init: function init(id, item, num) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$returnData, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (!(num == 3)) {
                  _context.next = 11;
                  break;
                }

                _this.titleName = "换绑邮箱";
                _this.names = "换绑邮箱";
                _this.form = {};
                tid = {
                  user_id: id,
                  game: item.game,
                  platform: item.platform,
                  channel: item.channel
                };
                _context.next = 8;
                return returnData(tid);

              case 8:
                _yield$returnData = _context.sent;
                data = _yield$returnData.data;
                _this.searchData = _objectSpread({}, data);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    valChange: function valChange(val) {
      this.searchData["email"] = val;
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("refreshDataList");
      this.$emit("changeShow", false);
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this2.titleName == "换绑邮箱") {
            _this2.searchMark.game = _this2.searchData.game;
            _this2.searchMark.platform = _this2.searchData.platform;
            _this2.searchMark.channel = _this2.searchData.channel;
            _this2.searchMark.pkg = _this2.searchData.pkg;
            _this2.searchMark.user_id = _this2.searchData.user_id;
            _this2.searchMark.email = _this2.searchData.email;
            _this2.searchMark.ad_channel = _this2.searchData.ad_channel ? _this2.searchData.ad_channel : 'default';
            _this2.searchMark.ad_placement = _this2.searchData.ad_placement ? _this2.searchData.ad_placement : 'default';
            _this2.searchMark.game = _this2.searchData.game;
            _this2.searchMark.kind = 1;
            changeBindEmail(_this2.searchMark).then(function (res) {
              if (res.status == 200) {
                Message.success(res.message);

                _this2.resetForm("ruleForm");
              } else {
                Message.warning(res.message);

                _this2.resetForm("ruleForm");
              }
            });
          }
        } else {
          return false;
        }
      });
    }
  },
  clearData: function clearData() {
    this.form = {};
    this.searchplatforms = [];
    this.searchchannels = [];
    this.searchpkg = [];
  }
};